import { render, staticRenderFns } from "./HrDocumentDialog.vue?vue&type=template&id=ff2c3034&"
import script from "./HrDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./HrDocumentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports